



































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SidebarLogo'
})
export default class extends Vue {
  @Prop({ required: true }) private collapse!: boolean
  private title = this.$Cookies.get('organizationName').indexOf('上海勘察') !== -1 ? '智慧运维' : (this.$Cookies.get('organizationName') || '小梯同学')
}
